import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'
import { Scanner } from '@yudiel/react-qr-scanner'
import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import { ClientSideTable } from 'Presentation/Components/Table'
import useViewModel from './ViewModel'
import Switch from 'react-switch'

const ShippingRequestScanView: React.FC = () => {
  const { id, detailId, isUseCamera, inventories, TABLE_CONFIGS, scanCode, hasCamera, handleScan, setScanCode,toggleUseCamera } =
    useViewModel()

  return (
    <ViewPageTitle id={id ?? ''} detailId={detailId ?? ''}>
      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <div className='card mb-5'>
        <div className='card-body'>
          <div className='row gy-5'>
            <div className='col-6'>
              <h3 className='fs-4'>Scan Bar Code Here!</h3>
            </div>
            <div className='col-6'>
              <label>
                <span style={{ marginRight: 20 }}>ใช้งานกล้อง</span>
                <Switch onChange={toggleUseCamera} checked={isUseCamera} />
              </label>
            </div>
            {hasCamera && isUseCamera ? (
              <div className='col-12'>
                <Scanner
                  // facingMode='environment'
                  // delay={1000}
                  onScan={handleScan}
                  constraints={{ facingMode: 'environment' }}
                />
              </div>
            ) : (
              <div className='col-12'>
                <p>No camera found</p>
                <form
                  onSubmit={(e: any) => {
                    e.preventDefault()
                      handleScan([{ rawValue: scanCode }])
                  }}>
                  <input
                    type='text'
                    onChange={(e: any) => setScanCode(e.target.value)}
                    value={scanCode}
                    className='form-control form-control-sm'
                  />
                </form>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='card'>
        <div className='card-body'>
          <div className='row'>
            <div className='col-12'>
              <ClientSideTable data={inventories} columns={TABLE_CONFIGS} items_per_page={100} />
            </div>
          </div>
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { id: string; detailId: string }> = ({
  children,
  id,
  detailId,
}) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/shipping',
            title: 'Shipping request',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
          {
            isActive: false,
            isSeparator: false,
            path: `/shipping-request/${id}`,
            title: 'Detail',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'Scan',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
        ]}>
        Scan
      </PageTitle>

      {children}
    </>
  )
}

export default ShippingRequestScanView
